import styled from 'styled-components';
import {Field, Form as FormikForm} from 'formik';
import colors from '../../../lib/Colors';
import fonts from '../../../lib/Fonts';
import React from 'react';

import {sizeSwitch} from '../../../lib/Utils'


const StyledForm = styled(FormikForm)`
  font-family: ${fonts.family.workSans};
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
`;

const StyledFragment = styled(({size, isFirstInRow, isLastInRow, hideForWidget, isWidget, ...props}) => (
  <div {...props}/>))`
  display: ${props => (props.isWidget && props.hideForWidget) ? 'none' : 'block'};
  position: relative;
   margin: 0 ${props => ((props.size && !props.isLastInRow) ? 7.5 : 0)}px 0 0 !important;
   width: ${props => sizeSwitch(props.size)}% !important;
  & label {
    color: ${colors.blue};
    -webkit-font-smoothing: auto; /* TODO: Remove once we remove old JS/CSS from Hubspot */
  }
  & input {
    background-color: ${colors.white};
    font-size: 16px;
    padding: 10px 15px 0 5px;
    border-radius: 3px 3px 0 0;
    transition: border-bottom 0.3s ease-in-out;
    color: ${colors.black};
  }
`;

const StyledField = styled(({error, customServerError, ...props}) => (<Field {...props}/>))`
  box-sizing: border-box;
  background: ${colors.white};
  height: 42px;
  border: 1px solid transparent !important;
  width: 100% !important;
  color: ${colors.almostBlack} !important;
  &:focus {
    border: solid 1px ${colors.blue} !important;
    outline: none;
  }
  ${props => (
  props.error && {
    borderBottomColor: `${colors.red} !important`
  } || {
    marginBottom: '1.5rem',
    borderBottomColor: `${colors.blue} !important`
  }
)}
   ${props => (
  props.customServerError && {
    borderBottomColor: `${colors.red} !important`,
    marginBottom: '1.5rem',
  } || {
    borderBottomColor: `${colors.blue} `
  }
)}
`;

const StyledFloatLabel = styled(({error, hasvalue, ...props}) => (<label {...props}/>))`
  color: ${({error}) => error ? colors.red : colors.mediumGray} !important;
  position: absolute;
  transition:
    /* No transition alls as it's an expensive CSS paint */
    color .2s ease-in-out,
    font-size .2s ease-in-out,
    left .2s ease-in-out,
    top .2s ease-in-out;
  font-size: 1em;
  left: 6px;
  top: 12px;
  input:focus ~& {
    color: ${colors.blue} !important;
    font-size: 0.625em;
    top: 2px;
  }; 
  ${props => props.hasvalue && {
  color: props.error ? colors.red : colors.almostBlack,
  fontSize: '0.625em',
  top: '2px',
  fontStyle: 'normal'
}};
`;

const StyledErrorMessage = styled.div`
  display: flex;
  flex-direction: row;
  margin: .25rem 0 .25rem;
`;

const StyledButtonWrapper = styled.div`
  width: 100%;
`;

const StyledErrorImage = styled.div`
  position: absolute;
  right: 10px;
  top: 12px; 
`
const StyledErrorImageWrapper = styled.div`
  margin: auto 0.2rem;
`

const StyledErrorTitle = styled.p`
  font-family: ${fonts.family.workSans};
  font-size: 0.8rem;
  color: ${colors.red};
  margin: 0;
`

export {
  StyledForm,
  StyledField,
  StyledErrorMessage,
  StyledErrorImage,
  StyledButtonWrapper,
  StyledFloatLabel,
  StyledFragment,
  StyledErrorImageWrapper,
  StyledErrorTitle
};
